/**
 * Home's chats with Sabine. Each is its own saved thread
 * (SabineChatSession, source HOME_SABINE) keyed `<studioId>:<threadId>`, so
 * "New chat" starts another rather than wiping the last one, and every one
 * stays in the chat library. A thread saved before home chats could be more
 * than one is keyed by the studio id alone, and is still that studio's.
 *
 * Client-safe: no Prisma. The server picks which thread Home opens
 * (`findHomeThreadContextId` in lib/sabine-chat/service.js).
 */

/** A fresh thread's key in this studio. */
export function newHomeThreadContextId(workspaceId) {
  return `${workspaceId}:${crypto.randomUUID()}`;
}

/** Is this saved home thread one of this studio's? */
export function isHomeThreadOf(contextId, workspaceId) {
  if (!workspaceId || typeof contextId !== "string") return false;
  return contextId === workspaceId || contextId.startsWith(`${workspaceId}:`);
}
